/**
 * WordPress dependencies
 */
import { InnerBlocks } from '@wordpress/block-editor';

export default function QueryNoResultsSave() {
	return <InnerBlocks.Content />;
}
